logit.classes.SelectionButton =
    function(id, text, description, iconData, dataAttribute, action, isCloseAfterAction) {
        'use strict';

        this.id = id;
        this.text = text;
        this.description = description;
        this.icon = iconData.icon || '';
        this.isFilesystemImage = iconData.isFilesystemImage || false;
        this.cssClass = 'modal-selection-btn';
        this.dataAttribute = {
            name: dataAttribute.name || '',
            value: typeof(dataAttribute.value) === 'undefined' ? '' : dataAttribute.value,
        };
        this.action = action;
        this.isCloseAfterAction = isCloseAfterAction;
        this.containerClass = getContainerClass(this);
        this.html = getHtml(this);

        function getContainerClass(me) {
            return me.cssClass + '-container';
        }

        function getHtml(me) {
            var $html = $('<div class="col">' +
                '  <div class="btn btn-secondary clearfix ' +
                me.cssClass +
                '-container">' +
                '    <div class="col-md-12" >' +
                '        <div class="text-center icon-container pt-3 pb-2" style="font-size:4em">' +
                '        </div>' +
                '    </div>' +
                '    <div class="text-center col-lg-12 col-md-12 col-sm-12 ' +
                me.cssClass +
                '" type="button" data-' +
                me.dataAttribute.name +
                '=' +
                me.dataAttribute.value +
                ' > ' +
                '        ' +
                me.text +
                '    </div>       ' +
                '    <div class="modal-button-description col-lg-12 col-md-12 col-sm-12">' +
                '         ' +
                me.description +
                '     </div>     ' +
                '   </div>' +
                '</div>');
            var $iconContainer = $html.find('.icon-container');
            $iconContainer.append(getIcon(me));

            return $html;

            function getIcon(me) {
                if (me.isFilesystemImage === true) {
                    var imageElement = new Image();
                    imageElement.src = me.icon;
                    return imageElement;
                } else {
                    return '<i class="' + me.icon + '" ></i>';
                }
            }
        };
    };